export enum ActionTypes {
    FETCH_REQUESTS = 'organisation-requests-module/fetch-requests'
}
